import { ConfirmDialog } from "primereact/confirmdialog"

const CustomConfirmDialog = ({
  message,
  draggable = false,
  closable = true,
  visible = false,
  className,
  header,
  acceptLabel = "Sí",
  rejectLabel = "No",
  reject,
  style = {},
  ...props
}: $TSMigrationFixMe) => {
  return (
    <ConfirmDialog
      message={message}
      draggable={draggable}
      closable={closable}
      visible={visible}
      className={`${className} g-confirm-dialog`}
      header={header}
      acceptLabel={acceptLabel}
      rejectLabel={rejectLabel}
      reject={reject}
      style={{ ...style }}
      {...props}
    />
  )
}

export default CustomConfirmDialog
